import { Action, Reducer } from "redux";
import { AppThunkAction, remoteNOActions } from ".";

export const DISTANCE_NO_CHANGED = "DISTANCE_NO_CHANGED";

export interface DistanceOptionNo {
    id: string;
    value: number;
    unit: string;
    title: string;
}

export interface DistanceNoState {
    showMileageTextForTaxi?: boolean;
    mileageTextTaxi?: string;
    title?: string;
    help?: { title?: string; description?: string };
    label: { id?: string; title?: string };
    selectedId: string;
    values: DistanceOptionNo[];
}

// for dev. purposes
const defaults = {
    // localize;
    // title: "Räkna ut ditt pris",
    selectedId: "D12000",
    help: {
        title: "Hur långt kör du per år?",
        description: "Välj det milintervall som motsvarar hur många mil du kör på ett år. Priset på försäkringen påverkas av hur långt du kör.",
    },
    label: {
        id: "2",
        title: "Hur många mil kör du med bilen per år?",
    },
    values: [
        {
            id: "D12000",
            value: 12000,
            unit: "kilometers",
            title: "12000 km",
        },
        {
            id: "D8000",
            value: 8000,
            unit: "kilometers",
            title: "8000 km",
        },
    ],
};

type ValidAction = {
    type: typeof DISTANCE_NO_CHANGED;
    payload: { id: string };
};

export const reducer: Reducer<DistanceNoState> = (state: DistanceNoState = defaults, input: Action): DistanceNoState => {
    const action = input as ValidAction;

    switch (action?.type) {
        case DISTANCE_NO_CHANGED:
            return { ...state, selectedId: action.payload.id };

        default:
            return state;
    }
};

export const actions = {
    distanceNoChanged:
        (value: unknown): AppThunkAction<ValidAction | AppThunkAction<{}>> =>
            dispatch => {
                dispatch({
                    type: DISTANCE_NO_CHANGED,
                    payload: { id: value as string },
                });

                dispatch(remoteNOActions.requestPriceData());
            },
};
